import { useState } from "react";
import { Tag, Copy, Check } from "@phosphor-icons/react";
import { getStoredPromo } from "../lib/analytics";

export function PromoBanner() {
  const promo = getStoredPromo();
  const [copied, setCopied] = useState(false);
  if (!promo) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(promo); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch { /* ignore */ }
  };
  return (
    <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-8 -mt-2 mb-6" data-testid="promo-banner">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-4 py-2 text-sm text-emerald-200">
        <Tag size={14} weight="fill" />
        <span>Your partner code <b className="font-mono text-emerald-100" data-testid="promo-banner-code">{promo}</b> takes <b>50% off your first month</b> — applied automatically at checkout, right after your 7-day free trial.</span>
        <button type="button" onClick={copy} className="inline-flex items-center gap-1 text-emerald-100 hover:text-white text-xs font-bold" data-testid="promo-banner-copy">
          {copied ? <Check size={12} /> : <Copy size={12} />} {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
